module.exports = __webpack_public_path__ + "img/img_gate09.fc041aba.jpg";